import React from 'react';
import { FormComponent } from '../../../components/form/DynamicForm';
import { Form, Validators } from '../../../components/form/DynamicFormTs';
import { withRouter } from "react-router-dom";
import Http from '../../../Http';

class ZonaKm extends FormComponent {
  componentDidMount() {
    const disabled = false;
    this.FormConfig(
      {
        defaultUrl: 'zona-km/one',
        saveUrl: 'zona-km/save',
        backUrl: '/Catalogo/ZonasKm'
      },
      new Form([
        Form.Field('text', 'letra', 'Zona / Letra (ej. A, B, RESTO)', '', [Validators.required], 4, [], [], [], false, disabled),
        Form.Field('number', 'desde', 'KM Desde', 0, [Validators.required], 4, [], [], [], false, disabled),
        Form.Field('number', 'hasta', 'KM Hasta', 0, [Validators.required], 4, [], [], [], false, disabled),
        Form.Field('number', 'tiempo_horas', 'Tiempo Después de Salir a Ruta (Horas)', 0, [Validators.required], 6, [], [], [], false, disabled),
        Form.Field('select', 'id_sucursal', 'Sucursal (Vacío para Todas las Sucursales)', '', [], 6, [], [], [], false, disabled),
        Form.Field('checkbox', 'es_resto', '¿Es Resto de Zonas (Default / Fallback)?', false, [], 6, [], [], [], false, disabled),
        Form.Field('checkbox', 'activo', 'Activo', true, [], 6, [], [], [], false, disabled),
      ], ['Guardar'], 'Configuración de Zona / Rango KM y Horas'),
      this.formData
    );

    if (this.props.match && this.props.match.params && this.props.match.params.id) {
      this.LoadPreds();
    }
  }

  formData = async (form) => {
    let Res = await Http.get('zona-km/form');
    if (!Res.error) {
      const { sucursales } = Res.data;
      const sucursalOptions = [
        { id: '', sucursal: '[General - Todas las Sucursales]' },
        ...(sucursales || [])
      ];
      let newForm = Form.FieldOptions(form, 'id_sucursal', sucursalOptions, 'id', 'sucursal');
      return newForm;
    }
    return form;
  };

  getFieldVal = (name, defaultVal = '') => {
    const fields = this.state.FormData && this.state.FormData.Fields;
    if (!fields) return defaultVal;
    const f = fields.find(item => item.Name === name);
    if (!f || f.Value === undefined || f.Value === null || f.Value === '') return defaultVal;
    return f.Value;
  };

  renderCalculoLeyenda = () => {
    const letra = this.getFieldVal('letra', '');
    const desdeRaw = this.getFieldVal('desde', 0);
    const hastaRaw = this.getFieldVal('hasta', 0);
    const tiempoHorasRaw = this.getFieldVal('tiempo_horas', 0);
    const esResto = Boolean(this.getFieldVal('es_resto', false));

    const desde = Number(desdeRaw) || 0;
    const hasta = Number(hastaRaw) || 0;
    const tiempoHoras = Number(tiempoHorasRaw) || 0;

    const ahora = new Date();
    const formatoFecha = (fecha) => {
      return fecha.toLocaleTimeString('es-MX', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    };

    const horaSalida = formatoFecha(ahora);
    const horaEstimada = formatoFecha(new Date(ahora.getTime() + (tiempoHoras * 60 * 60 * 1000)));

    return (
      <div
        style={{
          margin: '15px 5px',
          padding: '16px 20px',
          backgroundColor: '#f0f7ff',
          border: '1px solid #bfdbfe',
          borderRadius: '8px',
          color: '#1e3a8a',
          fontSize: '13px',
          lineHeight: '1.5'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px', fontWeight: 'bold', fontSize: '14px', color: '#1d4ed8' }}>
          <svg style={{ width: 20, height: 20, marginRight: 8, flexShrink: 0, fill: '#2563eb' }} viewBox="0 0 24 24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
          </svg>
          <span>¿Cómo se realiza el cálculo para esta zona?</span>
        </div>

        {esResto ? (
          <div>
            <p style={{ margin: '4px 0' }}>
              Esta zona está marcada como <strong>RESTO DE ZONAS (Default / Fallback)</strong>.
            </p>
            <p style={{ margin: '4px 0' }}>
              Aplica de manera automática cuando la distancia calculada no entre en ningún rango específico registrado o no se cuente con coordenadas para la colonia destino.
            </p>
            <p style={{ margin: '6px 0 2px 0', fontWeight: '600', color: '#1e40af' }}>
              • Al pasar la guía a estatus <strong>"En ruta EAD" (Estatus 8)</strong>, se sumarán exactamente <strong>{tiempoHoras.toFixed(2)} horas</strong> a la hora de salida de la unidad.
            </p>
          </div>
        ) : (
          <div>
            <p style={{ margin: '4px 0', fontSize: '13.5px' }}>
              Esta zona {letra ? <strong>"{letra}"</strong> : ''} aplica para entregas con distancia <strong>desde {desde.toFixed(2)} km hasta {hasta.toFixed(2)} km exactos</strong> (medida lineal entre la sucursal de origen y la colonia destino).
            </p>
            
            <div style={{ margin: '8px 0', padding: '10px 14px', backgroundColor: '#ffffff', border: '1px solid #dbeafe', borderRadius: '6px' }}>
              <div style={{ fontWeight: 'bold', color: '#1e40af' }}>
                Fórmula exacta del cálculo:
              </div>
              <div style={{ fontFamily: 'monospace', color: '#0f172a', marginTop: '2px', fontSize: '13px' }}>
                Fecha y Hora de Salida a Ruta + {tiempoHoras.toFixed(2)} horas = Fecha y Hora Estimada de Entrega
              </div>
              <div style={{ fontSize: '12px', color: '#475569', marginTop: '4px' }}>
                Ejemplo: Si la unidad sale hoy a las <strong>{horaSalida}</strong>, la entrega estimada será exactamente a las <strong>{horaEstimada}</strong>.
              </div>
            </div>

            {/* Recomendación de continuidad de rangos */}
            <div style={{ margin: '10px 0 4px 0', padding: '8px 12px', backgroundColor: '#ecfdf5', border: '1px solid #a7f3d0', borderRadius: '6px', fontSize: '12px', color: '#065f46' }}>
              <div style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '4px' }}>
                <span>💡 Recomendación para configurar rangos continuos (sin huecos):</span>
              </div>
              <p style={{ margin: '3px 0' }}>
                Para que distancias intermedias con decimales (por ejemplo <strong>8.5 km</strong>) queden correctamente cubiertas, configure los rangos de forma continua:
              </p>
              <ul style={{ margin: '3px 0 3px 18px', padding: 0 }}>
                <li><strong>Zona A:</strong> 0 a 8 km (cubre de 0.00 a 8.00 km)</li>
                <li><strong>Zona B:</strong> 8 a 12 km (cubre de 8.01 a 12.00 km, incluyendo 8.5 km)</li>
                <li><strong>Zona C:</strong> 12 a 20 km (cubre de 12.01 a 20.00 km)</li>
              </ul>
              <p style={{ margin: '3px 0', fontSize: '11px', color: '#047857' }}>
                * El backend cuenta además con tolerancia a huecos: si se configuró 0-8 y 9-12, una entrega de 8.5 km se asigna automáticamente a la Zona B por haber superado el límite de la Zona A.
              </p>
            </div>
          </div>
        )}

        <div style={{ marginTop: '8px', paddingTop: '8px', borderTop: '1px dashed #bfdbfe', fontSize: '11.5px', color: '#2563eb' }}>
          <strong>Tope con Cita EAD:</strong> Si la guía tiene una Cita EAD activa con fecha y hora programada anterior a la suma calculada, el sistema topará la estimación a la fecha de la cita para no excederla.
        </div>
      </div>
    );
  };

  render() {
    return (
      <div>
        <this.FormRender extraComponent={this.renderCalculoLeyenda()} />
      </div>
    );
  }
}

export default withRouter(ZonaKm);
